var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ofline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ofline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0.141587409,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(4.000000, 5.000000)",
    stroke: "#80959D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9551382,6.49043905 C13.1841233,6.49043905 12.556935,5.88062694 12.554308,5.1316117 L12.2167347,5.1316117 C12.2154212,5.88062694 11.5869193,6.49043905 10.8159044,6.49043905 C10.0435761,6.49043905 9.41507425,5.87934985 9.41507425,5.12841896 L8.96085193,5.12841896 C8.96085193,5.87934985 8.44899905,6.49043905 7.67732749,6.49043905 C6.90499913,6.49043905 6.27715396,5.87934985 6.27715396,5.12841896 L5.93892393,5.12841896 C5.93892393,5.87934985 5.31042204,6.49043905 4.53875047,6.49043905 C3.7657654,6.49043905 3.13792025,5.87934985 3.13792025,5.12841896 L2.79903348,5.12841896 C2.79903348,5.87934985 2.17053159,6.49043905 1.39820325,6.49043905 C0.652801331,6.49043905 0.04334496,5.92213248 0,5.20887584 L1.96066649,0 L13.3920182,0 L15.3526847,5.20887584 C15.3093398,5.92213248 14.6992266,6.49043905 13.9551382,6.49043905 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.21596156,6.7714861 L1.21596156,14.8633132 C1.21596156,15.4155979 1.66367681,15.8633132 2.21596156,15.8633132 L12.9862947,15.8633132 C13.5385794,15.8633132 13.9862947,15.4155979 13.9862947,14.8633132 L13.9862947,6.428935",
    id: "Path-46"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-51",
    points: "5.12642382 15.4771594 5.12642382 10.1806203 10.2470484 10.1806203 10.2470484 15.7285322"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.979c9c4d697d9929b27b5609cba1ec46.svg";
export { ForwardRef as ReactComponent };